/**
 * Application footer component
 * Company branding and navigation links
 */
export function Footer() {
  return (
    <footer className="w-full py-6 px-4 text-center text-sm text-muted-foreground border-t">
      <div className="max-w-2xl mx-auto space-y-3">
        <p>
          Designed by{' '}
          <a 
            href="https://whiskerbyte.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="font-semibold text-foreground hover:text-primary transition-colors underline decoration-dotted underline-offset-4"
            aria-label="Visit whiskerByte - Professional App Development"
          >
            whiskerByte
          </a>
        </p>
        <div className="flex items-center justify-center gap-4 text-xs">
          <a 
            href="https://whiskerbyte.com" 
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
            aria-label="whiskerByte Home"
          >
            Home
          </a>
          <span>•</span>
          <a 
            href="https://whiskerbyte.com" 
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
            aria-label="About whiskerByte"
          >
            About
          </a>
          <span>•</span>
          <a 
            href="https://whiskerbyte.com" 
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
            aria-label="Contact whiskerByte"
          >
            Contact
          </a>
          <span>•</span>
          <a 
            href="https://whiskerbyte.com" 
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-foreground transition-colors"
            aria-label="More Apps by whiskerByte"
          >
            More Apps
          </a>
        </div>
        <p className="text-xs">
          &copy; {new Date().getFullYear()} whiskerByte. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

